<script setup lang="ts">
import { watch, reactive, onMounted } from 'vue';
import * as service from '@/services/parceirosService';

interface Props {
  modelValue?: number | null,
  placeholder?: string
}

var props = defineProps<Props>();
const emit = defineEmits(['update:modelValue', 'selected'])


var controle = reactive({
  items: [] as service.Categoria[],
  id: null as number | null,
  carregando: false,
  text: "",
  status: ""
})

onMounted(() => {
  buscarItens()
})



function selecionar() {

  var categoria =   controle.items.find(c => c.categoriaId === controle.id)
  if (categoria) {
    emit('update:modelValue', categoria.categoriaId)
    emit('selected', categoria)
  }
  else {
    emit('update:modelValue', null)
    emit('selected', null)
  }
}


// Watch para sincronizar com modelValue externo
watch<number | null | undefined>(() => props.modelValue, (newValue) => {
  controle.id = newValue ?? null;
})


function buscarItens() {
  controle.status = "Buscando...";

  service.obterCategorias()
  .then(response => {
    controle.items = response;
    controle.status = "";
  }).catch(error => {
    console.error("Erro ao buscar itens:", error);
    controle.status = `Erro ${error.message}`;
  })
}
</script>

<template>
    <select v-model="controle.id" class="form-select form-select-sm" @change="selecionar()">
        <option value="">- Selecione -</option>
        <option v-for="item in controle.items" :key="item.categoriaId" :value="item.categoriaId">
            {{ item.descricao }}
        </option>
    </select>
</template>

<style scoped>
  
</style>